import React from 'react';

const CertificationsForm = ({ data, onChange }) => {
  const addCertification = () => {
    onChange([...data, {
      name: '',
      issuer: '',
      date: '',
      link: ''
    }]);
  };

  const removeCertification = (index) => {
    const newData = data.filter((_, i) => i !== index);
    onChange(newData);
  };

  const updateCertification = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    onChange(newData);
  };

  return (
    <div className="form-section">
      <h2 className="section-title">Certifications</h2>
      <p className="section-description">
        List any professional certifications, licenses, or credentials that are relevant to your career.
        This section is optional but can strengthen your resume.
      </p>

      {data.length === 0 ? (
        <div style={{
          background: '#f8f9fa',
          padding: '2rem',
          borderRadius: '12px',
          textAlign: 'center',
          color: '#7f8c8d',
          marginBottom: '1rem'
        }}>
          <p style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🏆</p>
          <p style={{ fontSize: '1rem', fontWeight: '500', marginBottom: '0.5rem' }}>
            No Certifications Added Yet
          </p>
          <p style={{ fontSize: '0.9rem' }}>
            Click the button below to add your professional certifications
          </p>
        </div>
      ) : (
        data.map((cert, index) => (
          <div key={index} className="entry-card">
            <div className="entry-header">
              <span className="entry-number">Certification {index + 1}</span>
              <button
                className="remove-button"
                onClick={() => removeCertification(index)}
              >
                Remove
              </button>
            </div>

            <div className="form-group">
              <label className="form-label required">Certification Name</label>
              <input
                type="text"
                className="form-input"
                value={cert.name}
                onChange={(e) => updateCertification(index, 'name', e.target.value)}
                placeholder="AWS Certified Solutions Architect"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Issuing Organization</label>
              <input
                type="text"
                className="form-input"
                value={cert.issuer}
                onChange={(e) => updateCertification(index, 'issuer', e.target.value)}
                placeholder="Amazon Web Services"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Date Obtained</label>
              <input
                type="text"
                className="form-input"
                value={cert.date}
                onChange={(e) => updateCertification(index, 'date', e.target.value)}
                placeholder="June 2023"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Certification Link (Optional)</label>
              <input
                type="url"
                className="form-input"
                value={cert.link}
                onChange={(e) => updateCertification(index, 'link', e.target.value)}
                placeholder="https://coursera.org/verify/ABC123"
              />
              <p className="form-hint">
                Add a verification or credential URL (e.g., from Coursera, LinkedIn Learning, etc.)
              </p>
            </div>
          </div>
        ))
      )}

      <button className="add-button" onClick={addCertification}>
        + Add Certification
      </button>

      <div className="example-box" style={{
        background: '#fff3cd',
        padding: '1rem',
        borderRadius: '8px',
        marginTop: '1.5rem',
        fontSize: '0.9rem',
        color: '#856404',
        border: '1px solid #ffeaa7'
      }}>
        <strong>💡 Pro Tip:</strong>
        <p style={{ marginTop: '0.5rem', lineHeight: '1.6' }}>
          Only include certifications that are current and relevant to your target job. 
          Industry-recognized certifications (like AWS, PMP, CPA, etc.) can significantly 
          boost your resume's appeal to both ATS systems and hiring managers.
        </p>
      </div>
    </div>
  );
};

export default CertificationsForm;
